import React from "react";
import PropTypes from "prop-types";
import WidgetOptions from "../WidgetOptions";
import { Scrollbars } from "react-custom-scrollbars";

const DirectValueWidget = ({
    widgetHasError = false,
    widgetId = "",
    widgetDisplayName = "",
    interfaceName = "",
    value = "---",
    dateTime = "---",
    percentageValue = "",
    unitTypeSymbol = "",
    fontColor = "",
    backgroundColor = "",
    isEditMode = false,
    isDashboardFullScreen = false,
    onForceUpdateClick = () => { },
    onEditClick = () => { },
    onDuplicateClicked = () => { },
    onDeleteClicked = () => { },
}) => {
    return (
        <div className="widget">
            <div className="row" style={{ height: "100%" }}>
                <div className="controller-container col-lg-12">
                    <div className={"controller-value-area controller-value-background controller-column controller-element-1 "} style={{ backgroundColor: backgroundColor, color: fontColor }}>
                        <h3 style={{ fontWeight: "bold", fontSize: "20px" }} className="value-display">
                            {value + " " + unitTypeSymbol}<br />
                            <span><h4>{percentageValue}</h4></span>
                        </h3>
                    </div>
                    <div className="controller-element-2 controller-secondary-area">
                        <WidgetOptions
                            widgetHasError={widgetHasError}
                            isEditMode={isEditMode}
                            isDashboardFullScreen={isDashboardFullScreen}
                            showRefreshIcon={true}
                            className="widget-options-contained widget-options-effect"
                            onEditClicked={onEditClick}
                            onRefreshClicked={onForceUpdateClick}
                            onDuplicateClicked={onDuplicateClicked}
                            onDeleteClicked={onDeleteClicked}
                        />
                        <div className={"controller-info-area controller-element-2 "}>
                            <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={1000} style={{ height: "100%" }}>
                                <div className="controller-vertical-container controller-element-3">
                                    <span
                                        className="controller-element controller-text-align controller-element-2 wordBreak m-r-25"
                                        style={{ fontSize: '13px' }}>{interfaceName}</span>
                                    <span
                                        className="controller-element controller-text-align controller-element-3 wordBreak m-r-25"
                                        style={{
                                            fontSize: '16px',
                                            paddingTop: "0.2rem",
                                            paddingBottom: "0.2rem"
                                        }}><b>{widgetDisplayName}</b></span>
                                    <span
                                        className="controller-element controller-text-align controller-element-1 m-r-25"
                                        style={{ fontSize: '12px', paddingBottom: '10px' }}>{dateTime}</span>
                                </div>
                            </Scrollbars>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

DirectValueWidget.propTypes = {
    widgetHasError: PropTypes.bool,
    widgetId: PropTypes.string,
    widgetDisplayName: PropTypes.string,
    interfaceName: PropTypes.string,
    value: PropTypes.any,
    dateTime: PropTypes.string,
    percentageValue: PropTypes.string,
    unitTypeSymbol: PropTypes.string,
    fontColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    isEditMode: PropTypes.bool,
    isDashboardFullScreen: PropTypes.bool,
    onRefreshClicked: PropTypes.func,
    onForceUpdateClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDuplicateClicked: PropTypes.func,
};

export default DirectValueWidget;